import styled from 'styled-components';
import { ShieldCheckmark2Ic, StarIc } from '@dsch/dd-icons';
import Text from '../../../../../ToolkitV2/Text/Text';

export const Ratings = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S2};
  min-width: 0;
  white-space: nowrap;
`;

export const TrustedDealerBadge = styled(ShieldCheckmark2Ic)`
  color: ${({ theme }) => theme.colors.GREEN};
  height: ${({ theme }) => theme.spacing.M16};
  width: ${({ theme }) => theme.spacing.M16};
  min-width: ${({ theme }) => theme.spacing.M16};
`;

export const UserType = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Star = styled(StarIc)<{ $rating: boolean; $gap: boolean }>`
  color: ${({ $rating, theme }) =>
    $rating ? theme.colors.ORANGE : theme.colors.GREY_DARK};
  height: ${({ theme }) => theme.spacing.M16};
  width: ${({ theme }) => theme.spacing.M16};
  min-width: ${({ theme }) => theme.spacing.M16};
  // 8px gap minus 2px already accounted for by the flex parent gap, leaving us with 8px between the star and the seller type
  margin-left: ${({ theme, $gap }) =>
    $gap ? `calc(${theme.spacing.S8} -  ${theme.spacing.S2})` : '0'};
`;
